import { NotOffered } from "@platform/openapi-types";

import type { EditorValuesFilter } from "./components/PlanEditor/context/EditorValuesFilterContext";

/**
 * BTX (Build) surface filter: hides the `notOffered` sentinel from editable
 * enum dropdowns.
 *
 * Benefit definitions are shared with the Present/Quotes (PPX) surface, which
 * extends enums with both `notDisclosed` and `notOffered`. `notOffered` is a
 * Retrieve-Proposal (PPX) concept; the Build surface must not offer it for
 * selection. Stored values are unaffected — this only shapes the dropdown.
 */
export const stripNotOffered: EditorValuesFilter = (values) =>
  values.filter((value) => value !== NotOffered);
